import { pages } from '@/navigation/vertical'
import i18n from '@/libs/i18n'

function isNavItemSearchable(page) {
  if (!page.route || !page.title) return false
  if (typeof page.hide === 'function' && page.hide()) return false
  return true
}

export default function getSearchIndex() {
  return {
    pages: {
      key: 'title',
      data: pages().filter(isNavItemSearchable).map(page => ({
        title: i18n.te(page.title) ? i18n.t(page.title) : page.title,
        route: { name: page.route },
        icon: page.icon || 'FileTextIcon',
        stepsNames: page.stepsNames ?? [],
      })),
    },
  }
}
